import { render, staticRenderFns } from "./CollapsibleItemsSection.vue?vue&type=template&id=5f835627&scoped=true&"
import script from "./CollapsibleItemsSection.vue?vue&type=script&lang=js&"
export * from "./CollapsibleItemsSection.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleItemsSection.vue?vue&type=style&index=0&id=5f835627&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f835627",
  null
  
)

export default component.exports